/* tpl-atc-feedback.js (2026-10-29): tick + "Added" on the main PDP Add to cart. */
(function () {
  'use strict';
  if (window.__tplAtcFb) return;
  window.__tplAtcFb = true;

  var HOLD_MS = 1200;
  var timers = new WeakMap();

  function build() {
    var wrap = document.createElement('span');
    wrap.className = 'tpl-atc-tick';
    wrap.setAttribute('aria-hidden', 'true');
    wrap.innerHTML = '<svg viewBox="0 0 16 16" focusable="false"><path d="M3 8.5l3.2 3.2L13 4.8"/></svg><span>Added</span>';
    return wrap;
  }

  function show(btn) {
    var label = btn.querySelector('.btn-text');
    if (!label) return;
    var prior = timers.get(btn);
    if (prior) { clearTimeout(prior.t); } else {
      /* hold the current size so the swap can never shift layout */
      var r = btn.getBoundingClientRect();
      btn.style.minWidth = r.width + 'px';
      btn.style.minHeight = r.height + 'px';
      prior = {};
      label.replaceChildren(build());
      btn.setAttribute('data-tpl-atc-added', '');
    }
    try { if (navigator.vibrate) navigator.vibrate(12); } catch (e) {}
    prior.t = setTimeout(function () {
      var l = btn.querySelector('.btn-text');
      if (l && l.querySelector('.tpl-atc-tick')) {
        /* the bridge restores the same label ~300 ms later; its own 'Added' text is never shown again */
        l.textContent = btn.getAttribute('data-add-text') || 'Add to cart';
      }
      btn.style.minWidth = '';
      btn.style.minHeight = '';
      btn.removeAttribute('data-tpl-atc-added');
      timers.delete(btn);
    }, HOLD_MS);
    timers.set(btn, prior);
  }

  document.addEventListener('cart:item-added', function (e) {
    var btn = e.detail && e.detail.trigger;
    if (!btn || !btn.matches || !btn.matches('[data-tpl-main-cta]')) return;
    /* let the bridge finish clearing its loading state first */
    setTimeout(function () { show(btn); }, 0);
  });
})();
